import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import Header from 'components/ui/Header';
import { supabase } from 'lib/supabase';
import { KeyRound } from 'lucide-react';

const ResetPassword = () => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e?.preventDefault();
    setError('');
    setLoading(true);

    try {
      const { error: resetError } = await supabase?.auth?.resetPasswordForEmail(email, {
        redirectTo: 'https://volaptic.com/update-password',
      });

      if (resetError) {
        setError('Si è verificato un errore. Verifica l\'indirizzo email e riprova.');
      } else {
        setSuccess(true);
      }
    } catch (err) {
      setError('Si è verificato un errore imprevisto. Riprova più tardi.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-background">
      <Header />
      <main
        className="pt-20 md:pt-24 pb-12 md:pb-16 px-4 md:px-6 lg:px-8"
        style={{
          backgroundImage: "linear-gradient(rgba(255,255,255,0.92), rgba(255,255,255,0.92)), url('/assets/images/reset_password_bg_soft.png')",
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundAttachment: 'fixed',
          minHeight: 'calc(100vh - 80px)'
        }}
      >
        <div className="max-w-md mx-auto flex items-center min-h-[calc(80vh-80px)]">
          <div className="bg-card border border-border rounded-2xl shadow-xl p-8 w-full">
            {success ? (
              <div className="text-center">
                <div className="flex items-center justify-center w-14 h-14 bg-green-100 rounded-full mx-auto mb-4">
                  <svg className="w-7 h-7 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                  </svg>
                </div>
                <p className="text-foreground text-base leading-relaxed">
                  Email inviata. Controlla la tua casella di posta e clicca sul link per reimpostare la password.
                </p>
                <Link
                  to="/login-form"
                  className="inline-block mt-6 text-sm text-primary hover:underline font-medium"
                >
                  Torna al login
                </Link>
              </div>
            ) : (
              <>
                <div className="flex items-center justify-center w-12 h-12 bg-blue-100 rounded-full mx-auto mb-4">
                  <KeyRound size={22} color="#2780b5" />
                </div>
                <h1 className="text-2xl font-bold text-foreground mb-2">
                  Reimposta la password
                </h1>
                <p className="text-muted-foreground text-sm mb-6">
                  Inserisci la tua email e ti invieremo un link per reimpostare la password.
                </p>

                <form onSubmit={handleSubmit} noValidate>
                  <div className="mb-4">
                    <label htmlFor="email" className="block text-sm font-medium text-foreground mb-1.5">
                      Email
                    </label>
                    <input
                      id="email"
                      type="email"
                      required
                      value={email}
                      onChange={(e) => setEmail(e?.target?.value)}
                      placeholder="nome@esempio.com"
                      className="w-full px-3 py-2.5 rounded-lg border border-border bg-background text-foreground placeholder:text-muted-foreground text-sm focus:outline-none focus:ring-2 focus:ring-primary/30 focus:border-primary transition-colors duration-200"
                    />
                  </div>

                  {error && (
                    <p className="text-sm text-red-600 mb-4">{error}</p>
                  )}

                  <button
                    type="submit"
                    disabled={loading || !email}
                    className="w-full py-2.5 px-4 bg-primary text-white text-sm font-semibold rounded-lg hover:bg-primary/90 disabled:opacity-50 disabled:cursor-not-allowed transition-colors duration-200"
                  >
                    {loading ? 'Invio in corso...' : 'Invia link di ripristino'}
                  </button>
                </form>

                <div className="mt-5 text-center">
                  <Link
                    to="/login-form"
                    className="text-sm text-primary hover:underline font-medium"
                  >
                    Torna al login
                  </Link>
                </div>
              </>
            )}
          </div>
        </div>
      </main>
    </div>
  );
};

export default ResetPassword;
